(() => {
  const FREQUENCY_REQUEST = 'subscription-frequency';
  const SUBSCRIPTION_TOPIC = 'Subscription, return or refund';
  const REQUEST_PROMPT = 'Please change my subscription delivery frequency to:\n\n';

  const initialiseFrequencyRequest = () => {
    const params = new URL(window.location.href).searchParams;

    if (params.get('request') !== FREQUENCY_REQUEST) return;

    const form = document.querySelector('[data-h7-contact-form]');
    if (!form) return;

    const introduction = form.querySelector('[data-h7-frequency-request]');
    const topic = form.querySelector('#ContactForm-topic');
    const body = form.querySelector('#ContactForm-body');
    const submitLabel = form.querySelector('[data-h7-contact-submit-label]');

    if (introduction) introduction.hidden = false;
    if (topic) topic.value = SUBSCRIPTION_TOPIC;
    if (body && !body.value.trim()) body.value = REQUEST_PROMPT;
    if (submitLabel) submitLabel.textContent = 'Send frequency request';
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseFrequencyRequest, { once: true });
  } else {
    initialiseFrequencyRequest();
  }
})();
